import { render, staticRenderFns } from "./ProfileCertificationItem.vue?vue&type=template&id=7234b86c&scoped=true&"
import script from "./ProfileCertificationItem.vue?vue&type=script&lang=js&"
export * from "./ProfileCertificationItem.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCertificationItem.vue?vue&type=style&index=0&id=7234b86c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7234b86c",
  null
  
)

export default component.exports